/**
 * @file defines util maps
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

/**
 *  Mapping the key of TreeNode to states in Win20CustomPageObjects.json
 * the key is the value of 'key' for each TreeNode in FeatureSelection Page
 * the value is the corresponding state of that TreeNode
 * @type {Map}
 */
export const featureKey2StateMap = new Map([
    ['1', 'intelligenceSelect'],
    ['1.4', 'intelligenceOLAPServicesSelect'],
    ['1.3', 'intelligenceReportServicesSelect'],
    ['1.5', 'intelligenceDistributionServicesSelect'],
    ['1.6', 'intelligenceTransactionServicesSelect'],
    ['2.1', 'webServerASPNETSelect'],
    ['2.2', 'webServerJSPSelect'],
    ['2.3', 'webAnalystSelect'],
    ['2.4', 'webProfessionalSelect'],
    ['2.5', 'webReporterSelect'],
    ['2.6', 'gisConnectorsSelect'],
    ['3', 'microStrategyRepositorySelect'],
    ['4.1', 'libraryWebMobileSelect'],
    ['4.2', 'collaborationSelect'],
    ['4.3', 'storageServiceSelect'],
    ['5.1', 'officeSelect'],
    ['5.2.1', 'webServicesASPNETSelect'],
    ['5.2.2', 'webServicesJSPSelect'],
    ['6', 'mobileSelect'],
    ['6.1', 'mobileServerASPSelect'],
    ['6.2', 'mobileServerJSPSelect'],
    ['7', 'cloudConnectorSelect'],
    ['8', 'communityConnectorsSelect'],
    ['9.1', 'analystSelect'],
    ['9.2', 'developerSelect'],
    ['9.3', 'architectSelect'],
    ['9.3.1', 'functionPluginSelect'],
    ['9.4', 'serverAdminSelect'],
    ['10', 'telemetryServerSelect'],
    ['11', 'objectManagerSelect'],
    ['12', 'commandManagerSelect'],
    ['13', 'enterpriseManagerSelect'],
    ['14', 'integrityManagerSelect'],
    ['15', 'systemManagerSelect'],
    ['16.1', 'ncsAdminSelect'],
    ['16.2', 'deliveryEngineSelect'],
    ['16.3', 'subscriptionPortalSelect'],
    ['16.4.1', 'tutorialDeliveryInstallSelect'],
    ['16.4.2', 'tutorialDeliveryConfigureSelect'],
    ['17', 'certificateStoreSelect'],
    ['18', 'platformAnalyticsSelect'],
    ['19', 'analyticsModulesSelect'],
    ['20', 'exportSelect'],
    ['21.1', 'sequeLinkSelect'],
    ['21.2', 'mdxCubeProviderSelect'],
    ['21.3', 'tomcatSelect'],
]);

/**
 * Mapping the picture url to specific state in order to control the picture
 * display in wev&mobileVDS and portal&mdxVDS pages in Windows Installation.
 * The key is the url of picture
 * The value is the state in Win20CustomPageObjects.json
 * @type {Map}
 */
export const pic2StateMap = new Map([
    // windows 2020
    [
        'assets/ReferencePics/Windows/MicroStrategy Web (ASP .NET) setting.png',
        'webServerASPNETSelect',
    ],
    ['assets/ReferencePics/Windows/Open Source Download.png', 'mySQLSelect'],
    [
        'assets/ReferencePics/Windows/MicroStrategy Mobile Server (ASP .NET) Virtual Directory Name.png',
        'mobileServerASPSelect',
    ],
    [
        'assets/ReferencePics/Windows/MicroStrategy Subscription Portal Virtual Directory Name.png',
        'subscriptionPortalSelect',
    ],
    [
        'assets/ReferencePics/Windows/MicroStrategy MDX Cube Provider Virtual Directory Name.png',
        'mdxCubeProviderSelect',
    ],
]);
